module.exports = __webpack_public_path__ + "media/brands/trabant-d3fe26e8.png";